import { Component, Inject, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OccEndpointsService } from '@spartacus/core';
import { Observable, of, Subscription } from 'rxjs';
import { kbBrakeAppService } from 'src/app/services/feature/kb-brakeApplication/KbBrakeApplication.service';
import { KbFileService } from 'src/app/services/feature/myacc-popup-fileService/kbfileService.service';

@Component({
  selector: 'app-brake-app-admin-dialog-popup',
  templateUrl: './brake-app-admin-dialog-popup.component.html',
  styleUrls: ['../brake-app-admin-form.component.scss', '../../kbBrakeApllicationForms-module/kbBrakeApllicationForms-module.component.scss'],
  standalone: false
})
export class BrakeAppAdminDialogPopupComponent {
  isDuplicateFile: boolean = false;
  isMaxFileSize: boolean = false;
  isUploadfileSuccess: boolean = false;
  isAtleastOnefileIsThere: boolean = true;
  productNotFound = undefined;
  baseUrl: string = '';
  lengthofFile: number = 0;
  fileLength$: Observable<any> = this.fileService.getCurrentFileCount();
  fileCurrentFiles$: Observable<any> = this.fileService.getCurrentFilesInfo();
  filesFromApi$: Observable<any>;
  subscription = new Subscription();
  private timeout?: ReturnType<typeof setTimeout> | null = null;// Store the timeout ID
  constructor(
    @Inject(MAT_DIALOG_DATA) public _data,
    private fileService: KbFileService,
    private brakeAppService: kbBrakeAppService,
    private occService: OccEndpointsService
  ) {
    this.filesFromApi$ = of(_data);
    this.lengthofFile = _data?.length;
    this.baseUrl = this.occService.getBaseUrl({
      baseUrl: true,
      prefix: false,
      baseSite: false,
    });
  }
  fileSelector(event: any) {
    const files = Object.values(event.files);
    const TotalFileSizeExceeds = this.fileService.isTotalFileSizeLessThan9MB();

    files.map((file: File) => {
      if ((!this.fileService.isFileSizeLessThan9MB(file)) || !TotalFileSizeExceeds) {
        this.isMaxFileSize = true;
      }
      else if (!this.fileService.isNotDuplicate(file.name)) {
        this.isDuplicateFile = true;
      }
      else {
        this.fileService.addFile(file);
        this.isAtleastOnefileIsThere = !this.fileService.isAtLeastOneFilePresent();
      }
    });


    this.timeout = setTimeout(() => {
      this.isDuplicateFile = false;
      this.isMaxFileSize = false;
      this.isUploadfileSuccess = false;
    }, 7000);

  }
  removefile(file: File) {
    this.fileService.deleteFile(file.name);
    this.isAtleastOnefileIsThere = !this.fileService.isAtLeastOneFilePresent();
  }
  removefileFromApi(fileCode: string) {
    this.subscription.add(this.brakeAppService.adminRemovefileApi(fileCode).subscribe((res: any) => {

    }));
  }
  fileUploadFunction() {

    this.isAtleastOnefileIsThere = this.fileService.isAtLeastOneFilePresent();
    if (this.isAtleastOnefileIsThere) {
      this.isUploadfileSuccess = true;
    }
    this.timeout = setTimeout(() => {
      this.isUploadfileSuccess = false;
    }, 7000);
    const file = this.fileService.getAllFiles();
  }
  ngOnDestroy(): void {
    // Unsubscribe from the scroll event
    this.subscription.unsubscribe();
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

}
